
function UserIcon({ className = "h-5 w-5", ...props } = {}) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" className={className} aria-hidden="true" focusable="false" {...props}>
      <path d="M12 12.75c2.35 0 4.25-1.9 4.25-4.25S14.35 4.25 12 4.25 7.75 6.15 7.75 8.5s1.9 4.25 4.25 4.25Z" />
      <path d="M4.75 20c.8-3.35 3.55-5.25 7.25-5.25S18.45 16.65 19.25 20" />
    </svg>
  );
}

function ShieldCheckIcon({ className = "h-5 w-5", ...props } = {}) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true" focusable="false" {...props}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  );
}

function PercentIcon({ className = "h-4 w-4", ...props } = {}) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" className={className} aria-hidden="true" focusable="false" {...props}>
      <path d="m7 17 10-10" />
      <circle cx="7" cy="7" r="2" />
      <circle cx="17" cy="17" r="2" />
    </svg>
  );
}

function ClockIcon({ className = "h-6 w-6", ...props } = {}) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  );
}

export {ShieldCheckIcon, UserIcon, PercentIcon, ClockIcon}